// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3RYmL","label":"SetPasswdForm_label__34jSA"};